export default __webpack_public_path__ + "71003bfa91a45c80f60e05ce013281bb.svg";